// extracted by mini-css-extract-plugin
export var author = "navigation-module--author--ea55c";
export var banner = "navigation-module--banner--1e8d9";
export var bannerCtaButton = "navigation-module--bannerCtaButton--513c3";
export var bannerCtaText = "navigation-module--banner-cta-text--235b3";
export var bannerCtaWrapper = "navigation-module--banner-cta-wrapper--10428";
export var buttonLabel = "navigation-module--button-label--2694f";
export var buttonNavBar = "navigation-module--button-nav-bar--4d20d";
export var category = "navigation-module--category--40a2e";
export var companyLink = "navigation-module--company-link--906a5";
export var gradientLeft = "navigation-module--gradient-left--65087";
export var gradientRight = "navigation-module--gradient-right--f449f";
export var headline = "navigation-module--headline--4b25f";
export var headlinePost = "navigation-module--headline-post--08396";
export var languageSwitch = "navigation-module--language-switch--685bc";
export var mainNavigation = "navigation-module--main-navigation--f6d6f";
export var menu = "navigation-module--menu--6297f";
export var menuWrapper = "navigation-module--menu-wrapper--85910";
export var navItems = "navigation-module--nav-items--0940f";
export var paragraph = "navigation-module--paragraph--d210e";
export var plainLink = "navigation-module--plain-link--da108";
export var wrapper = "navigation-module--wrapper--c3b8b";